import { useApiClient } from "../../../hooks/useApiClient";
import useSWRImmutable from "swr/immutable";
import {
  type IMonitoringAmountResponse,
  type IMonitoringAmountObject,
} from "../types";

interface IResponse {
  data: IMonitoringAmountObject | null;
  isLoading: boolean;
}

export const useMonitoringAmount = (): IResponse => {
  const { apiClient } = useApiClient();

  // swrに引き渡すfetcher
  const fetcher = async (url: string): Promise<IMonitoringAmountResponse> => {
    const { data } = await apiClient.get<IMonitoringAmountResponse>(url);
    return data;
  };

  const toObjectList = (
    data: IMonitoringAmountResponse | undefined
  ): IMonitoringAmountObject | null => {
    if (data === undefined) {
      return null;
    }
    return data;
  };

  const { data: amount, isLoading } = useSWRImmutable(
    "/monitoring/amount",
    fetcher
  );

  return { data: toObjectList(amount), isLoading };
};
